export default __webpack_public_path__ + "static/media/cosmosdb.573a2a46.svg";